


















import {Component, Prop, Vue} from "vue-property-decorator";

@Component
export default class SideNotification extends Vue {
    @Prop(String) public tabName!: string;
    @Prop(String) public textTrad!: string;

    public addNotification(): void {
        this.$router.push({
            name: `notifications_${this.tabName}_create`
        });
    }
}

